module.exports = {
      id: "new-label-usage",
      viewBox: "0 0 26 10",
      url: __webpack_public_path__ + "svg-sprite-ef426a51ffa8e0d9106d678bb4289730.svg#new-label",
      toString: function () {
        return this.url;
      }
    }